import { Box } from '@mui/material'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import LoadingSpinner from './LoadingSpinner'
import { isSchoolLoadingErrorCode } from './loadingErrorCodes'

const DEFAULT_DEBUG_DELAY_MS = 3000
const MIN_DEBUG_DELAY_MS = 250
const MAX_DEBUG_DELAY_MS = 60000

const debugPreviewEnabled =
    process.env.NODE_ENV !== 'production' ||
    process.env.REACT_APP_ENABLE_LOADING_DEBUG === 'true'

export const getDebugLoadingDelay = (value: string | null) => {
    if (value === null || value.trim() === '') return DEFAULT_DEBUG_DELAY_MS

    const parsed = Number(value)
    if (!Number.isFinite(parsed)) return DEFAULT_DEBUG_DELAY_MS

    return Math.min(
        MAX_DEBUG_DELAY_MS,
        Math.max(MIN_DEBUG_DELAY_MS, parsed)
    )
}

const LoadingErrorPreview = () => {
    const { search } = useLocation()
    const params = useMemo(() => new URLSearchParams(search), [search])
    const errorCode = params.get('debugLoadingError')

    if (!debugPreviewEnabled || !isSchoolLoadingErrorCode(errorCode)) {
        return null
    }

    const delay = getDebugLoadingDelay(params.get('debugLoadingDelayMs'))

    return (
        <Box
            data-testid="loading-error-preview"
            sx={{
                position: 'fixed',
                inset: 0,
                zIndex: (theme) => theme.zIndex.modal + 1,
                backgroundColor: 'background.default',
            }}
        >
            <LoadingSpinner
                fillViewPortHeight
                fillViewPortWidth
                id="loading-error-preview-spinner"
                errorCode={errorCode}
                errorTimeoutMs={delay}
            />
        </Box>
    )
}

export default LoadingErrorPreview
